module.exports = __webpack_public_path__ + "yeni ö.s. 2.jpg?62b96f20302e8a635db9740e062a5dd5";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni ö.s. 2.jpg
// module id = 397
// module chunks = 0